import { useEffect } from 'react';
import { useReducer } from 'react';
import 'firebase/auth';
import { getUserCustomer } from '../api/usercustomer.api';
import Axios from 'axios';
import {getAuth, onAuthStateChanged} from "firebase/auth"

export namespace UserStoreNS {
  export type State = {
    user: UserCustomerModel | null;
  };

  export type Store = [State, React.Dispatch<Action>];

  export type Action = { type: 'setUser'; payload: State['user'] };
}

const useUserStore = () => {
  const initState: UserStoreNS.State = {
    user: null,
  };

  const storeReducer = (
    storeState: UserStoreNS.State,
    action: UserStoreNS.Action,
  ): UserStoreNS.State => {
    switch (action.type) {
      case 'setUser': {
        return { ...storeState, user: action.payload };
      }
      default:
        throw new Error('Could not find state type in User store');
    }
  };

  const reducer = useReducer(storeReducer, initState);
  const [s, r] = reducer;

  useEffect(() => {
    const ct = Axios.CancelToken.source();
    const auth = getAuth();
    const unlisten = onAuthStateChanged(auth,(u) => {
      if (s.user === null && u && !u.isAnonymous) {
        // fetch user from db
        u.getIdToken().then((idToken) => {
          console.log('Fetching user');
          getUserCustomer(idToken, ct)
            .then((res) => r({ type: 'setUser', payload: res }))
            .catch(() => console.log('Error fetching user customer :('));
        });
      } else {
        console.log('NAT fetching user NAT');
      }
    });

    return () => {
      unlisten();
      ct.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [s.user]);

  return reducer;
};

export default useUserStore;
